import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { map } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CartTemplateContext } from '@b2b/components/cms/sections/cx-cart-section/cx-cart-section.component';
import { CartTotalsComponent } from '@b2b/components/cart/cart-totals/cart-totals.component';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { CheckoutService } from '@b2b/features/cart/core/checkout.service';
import { CheckoutTabsComponent } from '@b2b/components/checkout/checkout-tabs/checkout-tabs.component';

@Component({
  selector: 'checkout-completed',
  imports: [CommonModule, RouterModule, CartTotalsComponent, CheckoutTabsComponent, TranslateModule],
  templateUrl: './checkout-completed.component.html',
  styleUrl: './checkout-completed.component.scss',
})
export class CheckoutCompletedComponent {
  cart$ = this.cartService.getCart();

  templateContext$ = this.cart$.pipe(
    map(
      cart =>
        ({
          cart,
          isEmpty: (cart.data?.entries?.length ?? 0) === 0,
        }) as CartTemplateContext,
    ),
  );

  tabs = this.checkoutService.itemsTabs('completed');

  constructor(
    private cartService: CartService,
    private checkoutService: CheckoutService,
  ) {}

  // ngOnInit(): void {
  //   this.cartService.loadCart(this.cartService.getCartID());
  // }
}
